import type { ServiceStatus } from "@houston/shared";

const DOT: Record<ServiceStatus, string> = {
  healthy: "bg-[var(--color-healthy)]",
  degraded: "bg-[var(--color-warning)] animate-beacon",
  unhealthy: "bg-[var(--color-critical)] animate-beacon",
  unknown: "bg-[var(--color-text-dim)]",
};

const LABEL: Record<ServiceStatus, string> = {
  healthy: "text-[var(--color-text-secondary)]",
  degraded: "text-[var(--color-warning)]",
  unhealthy: "text-[var(--color-critical)]",
  unknown: "text-[var(--color-text-dim)]",
};

export function GlowIndicator(props: { label: string; status: ServiceStatus }) {
  return (
    <div class="group flex items-center gap-1.5 cursor-default" title={`${props.label}: ${props.status}`}>
      <span class={`h-[6px] w-[6px] rounded-full transition-all ${DOT[props.status]}`} />
      <span class={`font-mono text-[8px] font-medium uppercase tracking-[0.15em] transition-colors ${LABEL[props.status]}`}>
        {props.label}
      </span>
    </div>
  );
}
